var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-card",
        { staticClass: "my-card" },
        [_c("el-select", { attrs: { size: "medium" } }, [_c("el-option")], 1)],
        1
      ),
      _c(
        "el-card",
        { staticClass: "my-card" },
        [
          _c(
            "el-tabs",
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "应用信息" } },
                [
                  _c("p", { staticClass: "description" }, [
                    _vm._v(" 这些密钥是提供给每个商家的唯一凭据。"),
                    _c("br"),
                    _vm._v(
                      " 建议将商家密钥保留在服务器端，不应与任何人共享。 "
                    ),
                  ]),
                  _c(
                    "el-row",
                    { staticClass: "my-row" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12, xs: "24", sm: "12" } },
                        [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("AppId"),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v("100000360"),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12, xs: "24", sm: "12" } },
                        [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("AppName"),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v("Apna Rummy"),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12, xs: "24", sm: "12" } },
                        [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("ChannelCode"),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v("31SPDADK"),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12, xs: "24", sm: "12" } },
                        [
                          _c("div", { staticClass: "grid-content" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("Server Key"),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v("3QN6OTGI4A6WPJSX"),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Webhook Url" } },
                [
                  _c("p", { staticClass: "description" }, [
                    _vm._v(
                      "您可以配置 Webhook URL 以在支付完成后获取回调通知。"
                    ),
                  ]),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { xs: "24" } }, [
                        _c("div", { staticClass: "grid-content" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v("收款URL"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "value no-bb" },
                            [
                              _c("el-input", { attrs: { disabled: "" } }),
                              _c(
                                "div",
                                { staticClass: "right-btn" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.Edit")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("el-col", { attrs: { xs: "24" } }, [
                        _c("div", { staticClass: "grid-content" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v("付款URL"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "value no-bb" },
                            [
                              _c("el-input", { attrs: { disabled: "" } }),
                              _c(
                                "div",
                                { staticClass: "right-btn" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.Edit")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "收款" } },
                [
                  _c("div", { staticClass: "title-wrapper" }, [
                    _vm._v(" 交易额度 "),
                  ]),
                  _c("table", { staticClass: "my-table" }, [
                    _c("tr", [
                      _c("td", [_vm._v("单笔限额")]),
                      _c("td", [_vm._v("10~20000")]),
                    ]),
                    _c("tr", [
                      _c("td", [_vm._v("单日限额")]),
                      _c("td", [_vm._v("10000")]),
                    ]),
                  ]),
                  _c("div", { staticClass: "title-wrapper" }, [
                    _vm._v(" 商品消息 "),
                  ]),
                  _c(
                    "el-table",
                    [
                      _c("el-table-column", { attrs: { label: "创建时间" } }),
                      _c("el-table-column", { attrs: { label: "用户ID" } }),
                      _c("el-table-column", { attrs: { label: "应用 ID" } }),
                      _c("el-table-column", { attrs: { label: "应用名称" } }),
                      _c("el-table-column", { attrs: { label: "平台订单号" } }),
                      _c("el-table-column", { attrs: { label: "" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-tab-pane", { attrs: { label: "付款" } }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }